import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import dataV from '@jiaminghi/data-view'
//引入echart
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
import 'echarts/map/js/china.js'

// 适配flex
import '@/utils/flexible.js';

import global from './utils/global' // 全局方法
Vue.use(global)


Vue.config.productionTip = false


Vue.use(ElementUI);
Vue.use(dataV)

new Vue({
  el: '#app',
  router,
  render: h => h(App)
});
